import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  CommonService
} from 'src/app/common.service';
import { DataTableComponent } from 'src/app/common/data-table/data-table.component';
import {
  GlobalSettings
} from 'src/app/global.settings';
import Utils from 'src/app/utils';

@Component({
  selector: 'app-report-naming-modal',
  templateUrl: './report-naming-modal.component.html'
})
export class ReportNamingModalComponent implements OnInit, OnChanges {

  reportName = ''; // holds the name of the downloaded report
  loadingMeatadata = false; // holds boolean flag to display loader while loading metadata list for the selected node
  metadataList = []; // holds list of metadata and their values for the selected node
  listOfColumn = [{
    name: 'Name',
    propName: 'metadata_name',
    class: ' ',
    type: 'text'
  },
  {
    name: 'Value',
    propName: 'metadata_value',
    class: '',
    type: 'text'
  }
  ]; // holds list of column for metadata table in naming modal

  @Input() selectedNode: any; // holds the data object of selected node
  @Input() selectedTaxonomyTitle = ''; // holds the title of selected taxonomy
  @Input() formatSelected = false; // holds selected format of the report to be downloaded

  @Output() reportDownloadEvent: EventEmitter<any>; // holds download event for emition 

  @ViewChild('dataTable') dataTable: DataTableComponent;

  constructor(private service: CommonService) {
    this.reportDownloadEvent = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.reportName = this.selectedTaxonomyTitle;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.reportName = this.selectedTaxonomyTitle;
    if (changes.formatSelected && changes.formatSelected.currentValue) {
      this.goToNamingConvention();
    }

  }


  // FUNCTION to fetch data of selected node and construct metadata list

  goToNamingConvention() {
    this.loadingMeatadata = true;
    this.metadataList = [];
    let url = GlobalSettings.GET_TREE_ITEM_DETAIL + '/' + this.selectedNode.id;
    if (this.selectedNode['is_document'] === 1) {
      url = GlobalSettings.GET_CFDOC_ITEM_DETAIL + '/' + this.selectedNode.id;
    }

    this.service.getServiceData(url).then((res: any) => {
      const caseFields = Utils.caseField;
      console.log(caseFields, res);
      for (let i = 0; i < Object.keys(caseFields).length; i++) {
        const key = Object.keys(caseFields)[i];
        if (res[key]) {
          this.metadataList.push({
            metadata_id: i,
            metadata_name: caseFields[key],
            metadata_value: res[key],
            selected: false
          });
        }
      }
      for (let item of res.custom_metadata) {
        if (item.metadata_value.trim()) {
          this.metadataList.push({
            metadata_id: item.metadata_id,
            metadata_name: item.title,
            metadata_value: item.metadata_value,
            selected: false
          });
        }
      }

      if (this.dataTable) {
        this.dataTable.setData(this.metadataList);
      }

      this.loadingMeatadata = false;
    });
  }


  // Function to select and deselect metadata
  changeSelection(metadata) {
    this.reportName = '';
    this.metadataList.forEach(item => {
      if (metadata.find(data => data.metadata_id === item.metadata_id)) {
        this.reportName += Utils.extractContentFromHtml(item.metadata_value) + '_';
      }
    });

    if (metadata.length) {
      this.reportName += 'Curriculum Map';
    } else {
      this.reportName = Utils.extractContentFromHtml(this.selectedTaxonomyTitle);
    }

    console.log('report name', this.reportName);
  }

  // FUNCTION to initiate report download
  downloadIRM() {
    this.reportDownloadEvent.emit(this.reportName);
    this.onCancel();
  }

  // FUNCTION to cancel naming modal
  onCancel() {
    this.formatSelected = false;
    this.dataTable.clearAllSelection();
  }


}
